import Tag from '@/vuex/orm/fetcher/admin/models/Tag';

export default {

  data() {
    return {
      tagsLoaded: false,
    };
  },

  methods: {
    async loadTags(fromDb) {
      if (this.debug) { console.log('tags requested!'); }

      if (Tag.all().length === 0 || fromDb) {
        this.fetchTags();
      } else {
        if (this.debug) { console.log('tags already fetched!'); }

        this.tagsLoaded = true;
        Bus.$emit('tags_loaded');
      }
    },

    async fetchTags() {
      if (this.debug) { console.log('fetching tags...'); }

      await Tag.$fetch({
        query: {
          // token: this.$auth.token(),
          // limit: 100,
          // l: 'list',
        },
      });

      if (this.debug) { console.log('tags fetched!'); }

      this.tagsLoaded = true;
      Bus.$emit('tags_loaded');
    },
  },

  mounted() {
    Bus.$on('tags_loaded', () => {
      if (this.debug) { console.log('tags-loader.tags', Tag.all()); }
      if (this.showCount) { console.log('tags-loader.tags.count', Tag.query().count()); }
    });

    Bus.$on('refresh_tags', () => {
      this.loadTags(true);
    });
  },

  beforeDestroy() {
    Bus.$off('tags_loaded');
    Bus.$off('refresh_tags');
  },

};
